export enum MaterialId {
    Acacia = 'acacia',
    AcaciaEngineered = 'acaciaEngineered',
    AcaciaRecycled = 'acaciaRecycled',
    AcaciaVeneer = 'acaciaVeneer',
    AgedMirror = 'agedMirror',
    Alderwood = 'alderwood',
    AlderwoodEngineered = 'alderwoodEngineered',
    AlderwoodRecycled = 'alderwoodRecycled',
    AlderwoodVeneer = 'alderwoodVeneer',
    Aluminum = 'aluminum',
    Ash = 'ash',
    AshEngineered = 'ashEngineered',
    AshOlive = 'ashOlive',
    AshOliveEngineered = 'ashOliveEngineered',
    AshOliveRecycled = 'ashOliveRecycled',
    AshOliveVeneer = 'ashOliveVeneer',
    AshRecycled = 'ashRecycled',
    AshVeneer = 'ashVeneer',
    Beech = 'beech',
    BeechEngineered = 'beechEngineered',
    BeechRecycled = 'beechRecycled',
    BeechVeneer = 'beechVeneer',
    Birch = 'birch',
    BirchEngineered = 'birchEngineered',
    BirchRecycled = 'birchRecycled',
    BirchVeneer = 'birchVeneer',
    BlackLocust = 'blackLocust',
    Brass = 'brass',
    BronzeMirror = 'bronzeMirror',
    Caning = 'caning',
    CeramicKadum = 'ceramicKadum',
    CeramicKeo = 'ceramicKeo',
    CeramicKeranium = 'ceramicKeranium',
    CeramicManhattan = 'ceramicManhattan',
    CeramicNilium = 'ceramicNilium',
    CeramicOrix = 'ceramicOrix',
    CeramicStrato = 'ceramicStrato',
    CeramicWhiteConcrete = 'ceramicWhiteConcrete',
    Cherrywood = 'cherrywood',
    CherrywoodEngineered = 'cherrywoodEngineered',
    CherrywoodRecycled = 'cherrywoodRecycled',
    CherrywoodVeneer = 'cherrywoodVeneer',
    Chestnut = 'chestnut',
    ChestnutEngineered = 'chestnutEngineered',
    ChestnutRecycled = 'chestnutRecycled',
    ChestnutVeneer = 'chestnutVeneer',
    CompositeBlack = 'compositeBlack',
    CompositeBrown = 'compositeBrown',
    CompositeGrey = 'compositeGrey',
    CompositeIpe = 'compositeIpe',
    CompositeTaupe = 'compositeTaupe',
    CompositeTeak = 'compositeTeak',
    CompositeWhite = 'compositeWhite',
    ConcreteFibred = 'concreteFibred',
    ConcreteWaxed = 'concreteWaxed',
    CorianAnthracite = 'corianAnthracite',
    CorianBurledBeach = 'corianBurledBeach',
    CorianBurled = 'corianBurled',
    CorianCocoaPrima = 'corianCocoaPrima',
    CorianCosmosPrima = 'corianCosmosPrima',
    CorianDeepBlackQuartz = 'corianDeepBlackQuartz',
    CorianDusk = 'corianDusk',
    CorianEveningPrima = 'corianEveningPrima',
    CorianGlacierWhite = 'corianGlacierWhite',
    CorianGrayOnyx = 'corianGrayOnyx',
    CorianHazelnut = 'corianHazelnut',
    CorianLimestonePrima = 'corianLimestonePrima',
    CorianLinen = 'corianLinen',
    CorianNimbusPrima = 'corianNimbusPrima',
    CorianStratus = 'corianStratus',
    CorianTumbleweed = 'corianTumbleweed',
    CorianWhiteOnyx = 'corianWhiteOnyx',
    CorianXitchHazel = 'corianXitchHazel',
    Cumaru = 'cumaru',
    DarkGreyMirror = 'darkGreyMirror',
    DektonDanae = 'dektonDanae',
    DektonEther = 'dektonEther',
    DektonHelena = 'dektonHelena',
    DektonKhalo = 'dektonKhalo',
    DektonKira = 'dektonKira',
    DektonKylia = 'dektonKylia',
    DektonLaurent = 'dektonLaurent',
    DektonLiquidEmbers = 'dektonLiquidEmbers',
    DektonLiquidSky = 'dektonLiquidSky',
    DektonRem = 'dektonRem',
    DektonSoke = 'dektonSoke',
    DektonStrato = 'dektonStrato',
    DektonVienna = 'dektonVienna',
    DektonWhiteConcrete = 'dektonWhiteConcrete',
    Douglas = 'douglas',
    DouglasEngineered = 'douglasEngineered',
    DouglasRecycled = 'douglasRecycled',
    DouglasVeneer = 'douglasVeneer',
    DriftWood = 'driftWood',
    DriftWoodRecycled = 'driftWoodRecycled',
    Ebony = 'ebony',
    EbonyEngineered = 'ebonyEngineered',
    EbonyRecycled = 'ebonyRecycled',
    EbonyVeneer = 'ebonyVeneer',
    Elm = 'elm',
    ElmEngineered = 'elmEngineered',
    ElmRecycled = 'elmRecycled',
    ElmVeneer = 'elmVeneer',
    Fabric = 'fabric',
    FabricAcrylic = 'fabricAcrylic',
    FabricMicroPerforated = 'fabricMicroPerforated',
    FabricPolyester = 'fabricPolyester',
    Garapa = 'garapa',
    Glass = 'glass',
    GlassOpaque = 'glassOpaque',
    GlassVitroceramic = 'GlassVitroceramic',
    GraniteAbsoluteBlackZimbabwe = 'graniteAbsoluteBlackZimbabwe',
    GraniteAmazzonite = 'graniteAmazzonite',
    GraniteAzulAran = 'graniteAzulAran',
    GraniteBalmoral = 'graniteBalmoral',
    GraniteCambrianBlack = 'graniteCambrianBlack',
    GraniteCoffeeBrown = 'graniteCoffeeBrown',
    GraniteCoralRed = 'graniteCoralRed',
    GraniteGialloVeneziano = 'graniteGialloVeneziano',
    GranitePorrino = 'granitePorrino',
    GraniteRosaBeta = 'graniteRosaBeta',
    Ipe = 'ipe',
    IpeEngineered = 'ipeEngineered',
    IpeRecycled = 'ipeRecycled',
    IpeVeneer = 'ipeVeneer',
    Iroko = 'iroko',
    Iron = 'iron',
    Larch = 'larch',
    LarchEngineered = 'larchEngineered',
    LarchRecycled = 'larchRecycled',
    LarchVeneer = 'larchVeneer',
    Mahogany = 'mahogany',
    MahoganyEngineered = 'mahoganyEngineered',
    MahoganyRecycled = 'mahoganyRecycled',
    MahoganyVeneer = 'mahoganyVeneer',
    Maple = 'maple',
    MapleEngineered = 'mapleEngineered',
    MapleRecycled = 'mapleRecycled',
    MapleVeneer = 'mapleVeneer',
    MarbleArabescatoOribicoRosso = 'marbleArabescatoOribicoRosso',
    MarbleAzulImperial = 'marbleAzulImperial',
    MarbleBlackSahara = 'marbleBlackSahara',
    MarbleBrecciaPontificia = 'marbleBrecciaPontificia',
    MarbleBrecheDeVendome = 'marbleBrecheDeVendome',
    MarbleCalacatta = 'marbleCalacatta',
    MarbleCarrare = 'marbleCarrare',
    MarbleForestBrown = 'marbleForestBrown',
    MarbleGrandAntiqueAubert = 'marbleGrandAntiqueAubert',
    MarbleMarquina = 'marbleMarquina',
    MarblePortLaurent = 'marblePortLaurent',
    MarbleRosePortugal = 'marbleRosePortugal',
    MarbleSilverWave = 'marbleSilverWave',
    MarbleStriatoOlimpico = 'marbleStriatoOlimpico',
    MarbleTravertinClassicMedium = 'marbleTravertinClassicMedium',
    MarbleVerdeAlpi = 'marbleVerdeAlpi',
    MarbleVerdeGuatemala = 'marbleVerdeGuatemala',
    MarbleWhiteBeauty = 'marbleWhiteBeauty',
    MelamineAluminiumMetal = 'melamineAluminiumMetal',
    MelamineAnthraciteLarch = 'melamineAnthraciteLarch',
    MelamineAnthraciteMetal = 'melamineAnthraciteMetal',
    MelamineBarnWood = 'melamineBarnWood',
    MelamineBeigeUniform = 'melamineBeigeUniform',
    MelamineBlackBrownOak = 'melamineBlackBrownOak',
    MelamineBlackOak = 'melamineBlackOak',
    MelamineBlackUniform = 'melamineBlackUniform',
    MelamineBlackWood = 'melamineBlackWood',
    MelamineBlueUniform = 'melamineBlueUniform',
    MelamineBordeauxUniform = 'melamineBordeauxUniform',
    MelamineBrassMetal = 'melamineBrassMetal',
    MelamineBronzeConcrete = 'melamineBronzeConcrete',
    MelamineBrownLarch = 'melamineBrownLarch',
    MelamineBrushedAluminium = 'melamineBrushedAluminium',
    MelamineBrushedSteel = 'melamineBrushedSteel',
    MelamineCefalConcrete = 'melamineCefalConcrete',
    MelamineChalkWhite = 'melamineChalkWhite',
    MelamineChampagneMaple = 'melamineChampagneMaple',
    MelamineChestnutOak = 'melamineChestnutOak',
    MelamineClearBlueUniform = 'melamineClearBlueUniform',
    MelamineClearBrownUniform = 'melamineClearBrownUniform',
    MelamineClearConcrete = 'melamineClearConcrete',
    MelamineClearGrayConcrete = 'melamineClearGrayConcrete',
    MelamineClearGrayUniform = 'melamineClearGrayUniform',
    MelamineClearGreenUniform = 'melamineClearGreenUniform',
    MelamineDarkBlueUniform = 'melamineDarkBlueUniform',
    MelamineDarkBrownUniform = 'melamineDarkBrownUniform',
    MelamineDarkGrayConcrete = 'melamineDarkGrayConcrete',
    MelamineDarkGrayUniform = 'melamineDarkGrayUniform',
    MelamineDarkGreenUniform = 'melamineDarkGreenUniform',
    MelamineGrayArticUniform = 'melamineGrayArticUniform',
    MelamineGrayElm = 'melamineGrayElm',
    MelamineGrayOak = 'melamineGrayOak',
    MelamineGrayPine = 'melamineGrayPine',
    MelamineGreenUniform = 'melamineGreenUniform',
    MelamineIndigoMetal = 'melamineIndigoMetal',
    MelamineLightAcacia = 'melamineLightAcacia',
    MelamineMarbleAnthraciteGrigia = 'melamineMarbleAnthraciteGrigia',
    MelamineMarbleBlackGrigia = 'melamineMarbleBlackGrigia',
    MelamineMarbleWhiteLevanto = 'melamineMarbleWhiteLevanto',
    MelamineNaturalOak = 'melamineNaturalOak',
    MelamineNudeUniform = 'melamineNudeUniform',
    MelamineOrangeUniform = 'melamineOrangeUniform',
    MelaminePinkUniform = 'melaminePinkUniform',
    MelaminePolarPin = 'melaminePolarPin',
    MelaminePolarWhite = 'melaminePolarWhite',
    MelaminePurpleUniform = 'melaminePurpleUniform',
    MelamineRedUniform = 'melamineRedUniform',
    MelamineSandAsh = 'melamineSandAsh',
    MelamineSandChestnut = 'melamineSandChestnut',
    MelamineSandOak = 'melamineSandOak',
    MelamineStainlessSteel = 'melamineStainlessSteel',
    MelamineTabaccoOak = 'melamineTabaccoOak',
    MelamineTerracottaUniform = 'melamineTerracottaUniform',
    MelamineToneBeige = 'melamineToneBeige',
    MelamineToneBrown = 'melamineToneBrown',
    MelamineToneGrey = 'melamineToneGrey',
    MelamineToneWhite = 'melamineToneWhite',
    MelamineVintageOak = 'melamineVintageOak',
    MelamineWhiteConcrete = 'melamineWhiteConcrete',
    MelamineWhiteElm = 'melamineWhiteElm',
    MelamineWhiteLarch = 'melamineWhiteLarch',
    MelamineWhiteMarbleCarrarre = 'melamineWhiteMarbleCarrarre',
    MelamineWhiteOak = 'melamineWhiteOak',
    MelamineWhitePin = 'melamineWhitePin',
    MelamineWhiteWood = 'melamineWhiteWood',
    MelamineWoodDark = 'melamineWoodDark',
    MelamineWoodNatural = 'melamineWoodNatural',
    MelamineWoodWhite = 'melamineWoodWhite',
    MelamineWroughtIronBronze = 'melamineWroughtIronBronze',
    MelamineWroughtIronGrey = 'melamineWroughtIronGrey',
    MelamineYellowUniform = 'melamineYellowUniform',
    Muiracatiara = 'muiracatiara',
    OakRegular = 'oakRegular',
    OakRegularEngineered = 'oakRegularEngineered',
    OakRegularRecycled = 'oakRegularRecycled',
    OakRegularVeneer = 'oakRegularVeneer',
    OneWayMirror = 'oneWayMirror',
    Other = 'other',
    Padouk = 'padouk',
    PadoukEngineered = 'padoukEngineered',
    PadoukRecycled = 'padoukRecycled',
    PadoukVeneer = 'padoukVeneer',
    PavingStone = 'pavingStone',
    Pine = 'pine',
    PineEngineered = 'pineEngineered',
    PineRecycled = 'pineRecycled',
    PineVeneer = 'pineVeneer',
    PlexiglassFluorescent = 'plexiglassFluorescent',
    PlexiglassFrosted = 'plexiglassFrosted',
    PlexiglassMirror = 'plexiglassMirror',
    PlexiglassTransparent = 'plexiglassTransparent',
    PlexiglassWhite = 'plexiglassWhite',
    PolycarbonateOpaque = 'polycarbonateOpaque',
    PolycarbonateTeinted = 'polycarbonateTeinted',
    PolycarbonateTransparent = 'polycarbonateTransparent',
    Poplar = 'poplar',
    PoplarEngineered = 'poplarEngineered',
    PoplarRecycled = 'poplarRecycled',
    PoplarVeneer = 'poplarVeneer',
    Pvc = 'pvc',
    PvcRigid = 'pvcRigid',
    QuartzAzabache = 'quartzAzabache',
    QuartzBlackPortoro = 'quartzBlackPortoro',
    QuartzBotticino = 'quartzBotticino',
    QuartzChorme = 'quartzChorme',
    QuartzImperialBrown = 'quartzImperialBrown',
    QuartzWhiteFusion = 'quartzWhiteFusion',
    QuartzWhiteGalaxy = 'quartzWhiteGalaxy',
    QuartzWhitePlatinium = 'quartzWhitePlatinium',
    Ratan = 'ratan',
    RecycledPlastic = 'recycledPlastic',
    Redcedar = 'redcedar',
    RedcedarEngineered = 'redcedarEngineered',
    RedcedarRecycled = 'redcedarRecycled',
    RedcedarVeneer = 'redcedarVeneer',
    RiverEpoxyBlackOpaque = 'riverEpoxyBlackOpaque',
    RiverEpoxyBlackTransparent = 'riverEpoxyBlackTransparent',
    RiverEpoxyBlueOpaque = 'riverEpoxyBlueOpaque',
    RiverEpoxyBlueTransparent = 'riverEpoxyBlueTransparent',
    RiverEpoxyWhiteOpaque = 'riverEpoxyWhiteOpaque',
    RiverEpoxyWhiteTransparent = 'riverEpoxyWhiteTransparent',
    RiverGlassBlackOpaque = 'riverGlassBlackOpaque',
    RiverGlassBlackTransparent = 'riverGlassBlackTransparent',
    RiverGlassBlueOpaque = 'riverGlassBlueOpaque',
    RiverGlassBlueTransparent = 'riverGlassBlueTransparent',
    RiverGlassWhiteOpaque = 'riverGlassWhiteOpaque',
    RiverGlassWhiteTransparent = 'riverGlassWhiteTransparent',
    Rubber = 'rubber',
    RubberRecycled = 'rubberRecycled',
    Rust = 'rust',
    SilverMirror = 'silverMirror',
    SheetMetal = 'sheetMetal',
    SlabOutdoorArdoise = 'slabOutdoorArdoise',
    SlabOutdoorCerameGres = 'slabOutdoorCerameGres',
    SlabOutdoorConcrete = 'slabOutdoorConcrete',
    SlabOutdoorGranite = 'slabOutdoorGranite',
    SlabOutdoorMarbre = 'slabOutdoorMarbre',
    SlabOutdoorNaturalStone = 'slabOutdoorNaturalStone',
    SlabOutdoorReconstituedStone = 'slabOutdoorReconstituedStone',
    SlabOutdoorSlabGravel = 'slabOutdoorSlabGravel',
    SlabOutdoorTerracotta = 'slabOutdoorTerracotta',
    SlabOutdoorTravertin = 'slabOutdoorTravertin',
    SlabOutdoorWood = 'slabOutdoorWood',
    SlateBlack = 'slateBlack',
    SlateGrey = 'slateGrey',
    Spruce = 'spruce',
    SpruceEngineered = 'spruceEngineered',
    SpruceRecycled = 'spruceRecycled',
    SpruceVeneer = 'spruceVeneer',
    StainlessSteel = 'stainlessSteel',
    Steel = 'steel',
    StoneBlueHainot = 'stoneBlueHainot',
    StoneBourgogne = 'stoneBourgogne',
    StoneLens = 'stoneLens',
    StoneLuserne = 'stoneLuserne',
    StoneSerpentinite = 'stoneSerpentinite',
    Teak = 'teak',
    TeakEngineered = 'teakEngineered',
    TeakRecycled = 'teakRecycled',
    TeakVeneer = 'teakVeneer',
    Terracotta = 'terracotta',
    ThermoHeatedWoodAsh = 'thermoHeatedWoodAsh',
    ThermoHeatedWoodPine = 'thermoHeatedWoodPine',
    ThermoLaqueredBlack = 'thermoLaqueredBlack',
    ThermoLaqueredBlue = 'thermoLaqueredBlue',
    ThermoLaqueredGreen = 'thermoLaqueredGreen',
    ThermoLaqueredGrey = 'thermoLaqueredGrey',
    ThermoLaqueredOrange = 'thermoLaqueredOrange',
    ThermoLaqueredPink = 'thermoLaqueredPink',
    ThermoLaqueredRed = 'thermoLaqueredRed',
    ThermoLaqueredWhite = 'thermoLaqueredWhite',
    ThermoLaqueredYellow = 'thermoLaqueredYellow',
    TilesOutdoorBeigeStone = 'tilesOutdoorBeigeStone',
    TilesOutdoorBlackMarble = 'tilesOutdoorBlackMarble',
    TilesOutdoorBlackStone = 'tilesOutdoorBlackStone',
    TilesOutdoorConcreteBeige = 'tilesOutdoorConcreteBeige',
    TilesOutdoorConcreteBrown = 'tilesOutdoorConcreteBrown',
    TilesOutdoorConcreteDark = 'tilesOutdoorConcreteDark',
    TilesOutdoorConcreteGrey = 'tilesOutdoorConcreteGrey',
    TilesOutdoorConcreteWhite = 'tilesOutdoorConcreteWhite',
    TilesOutdoorDarkWood = 'tilesOutdoorDarkWood',
    TilesOutdoorGreyMarble = 'tilesOutdoorGreyMarble',
    TilesOutdoorGreyStone = 'tilesOutdoorGreyStone',
    TilesOutdoorGreyWood = 'tilesOutdoorGreyWood',
    TilesOutdoorLightWood = 'tilesOutdoorLightWood',
    TilesOutdoorNaturalStone = 'tilesOutdoorNaturalStone',
    TilesOutdoorWhiteMarble = 'tilesOutdoorWhiteMarble',
    TilesOutdoorWhiteStone = 'tilesOutdoorWhiteStone',
    WagonfloorDark = 'wagonfloorDark',
    WagonfloorLight = 'wagonfloorLight',
    OakOld = 'oakOld',
    Walnut = 'walnut',
    WalnutEngineered = 'walnutEngineered',
    WalnutRecycled = 'walnutRecycled',
    WalnutVeneer = 'walnutVeneer',
    Wenge = 'wenge',
    WengeEngineered = 'wengeEngineered',
    WengeRecycled = 'wengeRecycled',
    WengeVeneer = 'wengeVeneer',
    WroughtIron = 'wroughtIron',
    Zinc = 'zinc',
}

export enum MaterialClassId {
    Acacia = 'acacia',
    Alderwood = 'alderwood',
    Aluminum = 'aluminum',
    Ash = 'ash',
    AshOlive = 'ashOlive',
    Beech = 'beech',
    Birch = 'birch',
    Brass = 'brass',
    BlackLocust = 'blackLocust',
    Ceramic = 'ceramic',
    Cherrywood = 'cherrywood',
    Chestnut = 'chestnut',
    Composite = 'composite',
    Concrete = 'concrete',
    Corian = 'corian',
    Cumaru = 'cumaru',
    Dekton = 'dekton',
    Douglas = 'douglas',
    DriftWood = 'driftWood',
    Ebony = 'ebony',
    Elm = 'elm',
    Fabric = 'fabric',
    FabricAcrylic = 'fabricAcrylic',
    FabricMicroPerforated = 'fabricMicroPerforated',
    FabricPolyester = 'fabricPolyester',
    Garapa = 'garapa',
    Glass = 'glass',
    Granite = 'granite',
    Ipe = 'ipe',
    Iroko = 'iroko',
    Iron = 'iron',
    Larch = 'larch',
    Mahogany = 'mahogany',
    Maple = 'maple',
    Marble = 'marble',
    MelamineClearWoodEffect = 'melamineClearWoodEffect',
    MelamineConcreteEffect = 'melamineConcreteEffect',
    MelamineDarkWoodEffect = 'melamineDarkWoodEffect',
    MelamineMarbleEffect = 'melamineMarbleEffect',
    MelamineMetalEffect = 'melamineMetalEffect',
    MelamineTone = 'melamineTone',
    MelamineUniform = 'melamineUniform',
    MelamineWood = 'melamineWood',
    Mirror = 'mirror',
    Muiracatiara = 'muiracatiara',
    NaturalFiber = 'naturalFiber',
    Oak = 'oak',
    Other = 'other',
    Padouk = 'padouk',
    PavingStone = 'pavingStone',
    Pine = 'pine',
    Plexiglass = 'plexiglass',
    Polycarbonate = 'polycarbonate',
    Poplar = 'poplar',
    Pvc = 'pvc',
    Quartz = 'quartz',
    Ratan = 'ratan',
    RecycledPlastic = 'recycledPlastic',
    Redcedar = 'redcedar',
    RiverEpoxyOpaque = 'riverEpoxyOpaque',
    RiverEpoxyTransparent = 'riverEpoxyTransparent',
    RiverGlassOpaque = 'riverGlassOpaque',
    RiverGlassTransparent = 'riverGlassTransparent',
    Rubber = 'rubber',
    SheetMetal = 'sheetMetal',
    SlabOutdoor = 'slabOutdoor',
    Spruce = 'spruce',
    Steel = 'steel',
    StoneAndSlate = 'stoneAndSlate',
    Teak = 'teak',
    Terracotta = 'terracotta',
    ThermoHeatedWood = 'thermoHeatedWood',
    TilesOutdoor = 'tilesOutdoor',
    Wagonfloor = 'wagonfloor',
    Walnut = 'walnut',
    Wenge = 'wenge',
    WroughtIron = 'wroughtIron',
    Zinc = 'zinc',
}

export enum MaterialCategoryId {
    Ceramic = 'ceramic',
    Concrete = 'concrete',
    Fabric = 'fabric',
    Glass = 'glass',
    NaturalFiber = 'naturalFiber',
    MarbleAndStone = 'marbleAndStone',
    Melamined = 'melamined',
    Metal = 'metal',
    Mirror = 'mirror',
    Other = 'other',
    Plastic = 'plastic',
    RiverTable = 'riverTable',
    Terracotta = 'terracotta',
    Wood = 'wood',
}
